import { NAME as namespace } from './constants';
import { invoiceReducer as reducer } from './reducer';
export var invoice = {
  namespace: namespace,
  reducer: reducer
};
export default invoice;